class PickupAvailability extends HTMLElement {
    constructor(){
        super();

        this.productVariantSelectors = document.querySelectorAll('.product-variants-selector > select');

        this.productVariantSelectors.forEach((productVariantSelector) => {
            productVariantSelector.addEventListener('change', () => {
                this.onVariantChange(productVariantSelector);
            });
        });
    }

    onVariantChange(productVariantSelector){
        var selectedIndex = productVariantSelector.selectedIndex;
        var variantId = productVariantSelector[selectedIndex].getAttribute('value');
        var pickupAvailability = productVariantSelector.closest('.product').querySelector('pickup-availability');

        fetch(`/variants/${variantId}/?section_id=pickup-availability`)
            .then(response => response.text())
            .then(text => {
                var html = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');

                pickupAvailability.innerHTML = html.innerHTML;
            })
            .catch(e => {
                console.error(e);
            });
    }
}

customElements.define('pickup-availability', PickupAvailability);
